export const getIframeModeParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    isIframeMode: params.get('in_iframe') === 'true',
    token: params.get('token'),
    customerId: params.get('customerId'),
    hasRecommendation: params.get('hasRecommendation') === 'true',
    hasPersonalizedSupplementRecommendations: params.get('hasPersonalizedSupplementRecommendations') === 'true',
    isEligibleForSupplements: params.get('isEligibleForSupplements') === 'true',
  };
};
